class ChatRequestHandler {
	constructor() {
        this.api = null;
        this.handlers = {};
    }
    
    request(msg, handler) {        
    	if (!msg.id)
            msg.id = '' + new Date().getTime();
        if (handler)
            this.handlers[msg.id] = handler;
        this.api.sendMessage(msg);
    }

    onResponse(msg) {
        if (!msg.id) return;
        let handler = this.handlers[msg.id];
        if (!handler) return;
        try {
            handler(msg.result);
        } catch (e) {
        }
        delete this.handlers[msg.id];
    }
}

export let requestHandler = new ChatRequestHandler();